module.exports = __webpack_public_path__ + "img/exchangedollarfill.636945e0.svg";